module.exports = __webpack_public_path__ + "img/pay-pal-verified.3efc7871.svg";